import { createColumnHelper } from "@tanstack/react-table";
import {
  ArrowDownTrayIcon,
  CheckCircleIcon,
  ClockIcon,
  XCircleIcon,
} from "@heroicons/react/24/outline";
const columnHelper = createColumnHelper();

export const bulkSpareLotListTableColumnsConfig = (
  handleDownload,
  handleNavigate,
) => [
  columnHelper.accessor("id", {
    header: "Id",
    cell: (info) => info.getValue(),
    footer: (props) => props.column.id,
  }),
  columnHelper.accessor("brand", {
    header: "Brand",
    cell: (info) => info.getValue(),
    footer: (props) => props.column.id,
  }),
  columnHelper.accessor("model", {
    header: "Model",
    cell: (info) => info.getValue(),
    footer: (props) => props.column.id,
  }),



  
  columnHelper.accessor("color", {
    header: "Color",
    cell: (info) => info.getValue(),
    footer: (props) => props.column.id,
  }),

  columnHelper.accessor("quantity", {
    header: "Quantity",
    cell: (info) => info.getValue(),
    footer: (props) => props.column.id,
  }),
  columnHelper.accessor("price", {
    header: "Price",
    cell: (info) => info.getValue(),
    footer: (props) => props.column.id,
  }),

  columnHelper.accessor("retail_price_per_piece", {
    header: "Price/piece",
    cell: (info) => info.getValue(),
    footer: (props) => props.column.id,
  }),
  

 
  columnHelper.display({
    id: "actions",
    header: <div style={{ textAlign: "center" }}>Action</div>,
    cell: (props) => (
      <div
        style={{ display: "flex", justifyContent: "center", columnGap: "10px" }}
      >
        <button
          disabled={props.row.original.approval_status === "pending for status"}
          onClick={() => handleNavigate(props.row.original.id)}
          style={{
            padding: "6px 12px",
            background: "linear-gradient(135deg, #2F3567 0%, #5561A0 100%)",
            color: "#FFFFFF",
            fontWeight: 500,
            fontSize: "13px",
            border: "none",
            borderRadius: "6px",
            cursor: "pointer",
            transition: "all 0.3s ease",
            boxShadow: "0 2px 6px rgba(47,53,103,0.3)",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.background =
              "linear-gradient(135deg, #5561A0 0%, #7B82C0 100%)";
            e.currentTarget.style.boxShadow = "0 4px 12px rgba(47,53,103,0.35)";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.background =
              "linear-gradient(135deg, #2F3567 0%, #5561A0 100%)";
            e.currentTarget.style.boxShadow = "0 2px 6px rgba(47,53,103,0.3)";
          }}
        >
          View Detail
        </button>
      </div>
    ),
  }),
];
